"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PaymentConsentCheckbox", {
  enumerable: true,
  get: function get() {
    return _PaymentConsentCheckbox.PaymentConsentCheckbox;
  }
});
var _PaymentConsentCheckbox = require("./PaymentConsentCheckbox");